import { Box, Typography } from '@mui/material';
import { usePrefs } from '@/store/BuyerPrefsContext';
import brandLogo from '@/assets/brand-logo.png';

export default function BuyerFooter() {
  const { t } = usePrefs();
  return <Box component="footer" className="buyer-footer">
    <Box className="buyer-footer-content">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: .75 }}>
        <Box component="img" src={brandLogo} alt="" sx={{ width: { xs: 36, md: 42 }, height: { xs: 36, md: 42 }, objectFit: 'contain' }} />
        <Typography sx={{ fontSize: { xs: 19, md: 26 }, fontWeight: 700, lineHeight: 1, color: '#fff' }}>Bluplanet</Typography>
      </Box>
      <Typography sx={{ fontSize: { xs: 12, md: 15 }, lineHeight: 1.5, maxWidth: 580, color: '#e3f5ed' }}>{t('footer.slogan')}</Typography>

    </Box>
  </Box>;
}
